import { ViewMode } from '../../types/interfaces';
export function resolveKeyPress(playerContext, e) {
    const isMuted = playerContext.player.isMuted() ?? false;
    const isPaused = playerContext.player.isPaused() ?? false;
    const viewMode = playerContext.player.getViewMode();
    if (['Space', 'ArrowUp', 'ArrowDown'].includes(e.code))
        e.preventDefault();
    const actions = {
        KeyM: () => (isMuted ? playerContext.player.unmute() : playerContext.player.mute()),
        KeyF: () => viewMode === ViewMode.Fullscreen
            ? playerContext.player.setViewMode(ViewMode.Inline)
            : playerContext.player.setViewMode(ViewMode.Fullscreen),
        Space: () => {
            if (isPaused) {
                playerContext.player.play().catch((error) => {
                    console.error('Failed to play:', error);
                });
            }
            else {
                playerContext.player.pause();
            }
        },
        ArrowUp: () => {
            if (isMuted)
                playerContext.player.unmute();
            playerContext.npoplayer.increaseVolume();
        },
        ArrowDown: () => {
            if (isMuted)
                playerContext.player.unmute();
            playerContext.npoplayer.decreaseVolume();
        },
        ArrowLeft: () => playerContext.npoplayer.goBackwards(10),
        ArrowRight: () => playerContext.npoplayer.goForward(10),
        Escape: () => {
            const { settingsPanels } = playerContext.npoplayer.uiComponents;
            if (settingsPanels && settingsPanels.length > 0) {
                for (const panel of settingsPanels) {
                    if (panel.isShown()) {
                        panel.hide();
                    }
                }
            }
        }
    };
    const action = actions[e.code];
    if (action)
        action();
}
